import React from 'react'

export default function Error( { children } ) 
{
    return (
        <div className="error-text">{ children }</div>
    )
}
